<template>
    <div class="memberwork-box">
        <div>
            <img class="memberwork-img" @click="clickImg" :src="imgSrc">

            <div @click="clickRequest" class="apply-button">
                {{i18n.tkey("lang_collection_memberwork")}}
            </div>
        </div>

        <div class="close-button" @click="clickClose">
            <div>×</div>
        </div>
    </div>
</template>

<script setup>

import {inject} from "vue";

const props = defineProps(["imgSrc"])
const emits = defineEmits(["clickImg", "clickRequest", "clickClose"])

const i18n = inject("i18n")

function clickImg(){
    emits("clickImg")
}

function clickRequest(){
    emits("clickRequest")
}

function clickClose(){
    emits("clickClose")
}

</script>

<style scoped>
.memberwork-box {
    position: absolute;
    z-index: 400;
    width: 100%;
    height: 100%;
    background: #00000091;
    display: flex;
    left: 0;
    top: 0;
    align-items: center;
    justify-content: center;
}

@media screen and (min-width: 520px) {
    .memberwork-box .memberwork-img{
        width: 425px;
        height: 275px;
        animation: show-card-animation 1s ease;
    }
}

@media screen and (max-width: 520px) {
    .memberwork-box .memberwork-img{
        width: 80%;
        height: 52%;
        animation: show-card-animation 1s ease;
    }
}


@keyframes show-card-animation {

    0% {
        transform: scaleX(0) scaleY(0);
    }

    100% {
        transform: scaleX(1) scaleY(1);
    }

}

@media screen and (min-width: 520px) {
    .memberwork-box .close-button{
        background: #ebccd1;
        border: 1px #a94442 solid;
        color: #a94442;
        font-size: 36px;
        font-weight: 600;
        position: absolute;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        right: calc(50vw - 280px);
        top: calc(50vh - 200px);
        display: flex;
        align-items: center;
        justify-content: center;
        user-select: none;

    }
}

@media screen and (max-width: 520px) {
    .memberwork-box .close-button{
        background: #ebccd1;
        border: 1px #a94442 solid;
        color: #a94442;
        font-size: 36px;
        font-weight: 600;
        position: absolute;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        right: 10%;
        top: 24%;
        display: flex;
        align-items: center;
        justify-content: center;
        user-select: none;

    }
}

.memberwork-box .apply-button{
    border: 1px #3c763d solid;
    background: #3c763d;
    color: #d6e9c6;
    padding: 10px 25px;
    border-radius: 5px;
    width: 150px;
    margin: auto;
    margin-top: 20px;
    user-select: none;
    display: none;

}
</style>